import { $createMentionNode } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNodeSupport.js';
import { $createTextNode, $getSelection, $isRangeSelection } from 'lexical';
/**
 * Editor mutations that back the `ComposerEditorApi` a provider receives in
 * `onSelect`. Each runs inside an `editor.update()` and operates on a live
 * `TextNode` — resolved in the current update, never a reference captured from an
 * earlier one — plus the `[start, end)` span covering the trigger's prefix and query.
 */
/** Replace the trigger span with a rich mention token (+ optional trailing space). */
export function $insertTriggerToken({ node, start, end, props, trailingSpace = true, }) {
    // No legacy dedupe early-return: we always clear the typed trigger, so re-selecting an
    // existing mention never leaves the typed `@spa` behind.
    const mention = $createMentionNode(props);
    const trailing = trailingSpace ? $createTextNode(' ') : null;
    if (isWholeNode({ node, start, end })) {
        node.replace(mention);
        if (trailing) {
            mention.insertAfter(trailing);
        }
        $caretAfter(mention, trailing);
        return;
    }
    const text = node.getTextContent();
    node.setTextContent(text.slice(0, start) + text.slice(end));
    node.select(start, start);
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
        return;
    }
    selection.insertNodes(trailing ? [mention, trailing] : [mention]);
    $caretAfter(mention, trailing);
}
/** Replace the trigger span's query (prefix + query) with plain text. */
export function $replaceTriggerQuery({ node, start, end, text, }) {
    const content = node.getTextContent();
    node.setTextContent(content.slice(0, start) + text + content.slice(end));
    const caret = start + text.length;
    node.select(caret, caret);
}
/** Delete the trigger span (prefix + query) without inserting anything. */
export function $deleteTriggerSpan({ node, start, end, }) {
    if (isWholeNode({ node, start, end })) {
        const paragraph = node.getParentOrThrow();
        node.remove();
        paragraph.selectEnd();
        return;
    }
    const text = node.getTextContent();
    node.setTextContent(text.slice(0, start) + text.slice(end));
    node.select(start, start);
}
// The trigger may still be isolated or have merged into adjacent text before a deferred mutation.
function isWholeNode({ node, start, end, }) {
    return start === 0 && end === node.getTextContentSize();
}
/** Place a collapsed caret after `node`'s isolated mention, or after a trailing space. */
export function $caretAfter(mention, trailing) {
    if (trailing) {
        trailing.selectEnd();
        return;
    }
    // MentionNode is isolated; selecting its next sibling puts the caret right after the chip.
    mention.selectNext(0, 0);
}
//# sourceMappingURL=editorActions.js.map